import { shareMaxContentInMax } from "./share-content";

export type MaxReferralInviteOutcome = "shared" | "cancelled" | "unavailable" | "error";

export type MaxReferralInviteResult = {
    outcome: MaxReferralInviteOutcome;
    errorCode?: string;
};

export const shareReferralInviteInMax = async (params: { text: string; link?: string }): Promise<MaxReferralInviteResult> => {
    try {
        const { status } = await shareMaxContentInMax(params);
        return { outcome: status };
    } catch (e: unknown) {
        if (e instanceof Error && e.message === "MAX_SHARE_MAX_CONTENT_UNAVAILABLE") {
            return { outcome: "unavailable" };
        }

        const errorCode = (e as { error?: { code?: string } })?.error?.code;
        return { outcome: "error", errorCode };
    }
};

